import { render, staticRenderFns } from "./TeleMarketThirdTaskConfigEdit.vue?vue&type=template&id=4954d936&scoped=true"
import script from "./TeleMarketThirdTaskConfigEdit.vue?vue&type=script&lang=js"
export * from "./TeleMarketThirdTaskConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954d936",
  null
  
)

export default component.exports